import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../mock/mock";
import useInView from "../hooks/useInView";

export default function FAQ({ onContact }) {
  const [ref, inView] = useInView();

  return (
    <section id="faq" className="relative bg-[#0a1626] py-24">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 grid lg:grid-cols-[0.9fr_1.4fr] gap-12 lg:gap-20 items-start transition-all duration-700 ${
          inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="lg:sticky lg:top-28">
          <span className="text-xs font-bold tracking-[0.2em] text-[#F5941E]">
            FAQ
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            Questions fréquentes
          </h2>
          <p className="mt-4 text-slate-400 leading-relaxed">
            Tout ce que vous devez savoir sur notre approche et notre processus
            de recrutement.
          </p>
          <button
            onClick={onContact}
            className="mt-6 inline-flex items-center rounded-full bg-[#F5941E] hover:bg-[#e8850e] px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5"
          >
            Nous contacter
          </button>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.03] px-6 data-[state=open]:border-[#F5941E]/30 transition-colors"
            >
              <AccordionTrigger className="py-5 text-left text-base font-semibold text-white hover:no-underline hover:text-[#F5941E] [&>svg]:text-[#F5941E]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-slate-400 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
